import { writable } from "svelte/store";
import { assoc } from "@welshman/lib";
import { withGetter } from "@welshman/store";
import { decrypt } from "@welshman/signer";
import { getSigner, getSession } from "./session.js";
export const plaintext = withGetter(writable({}));
export const getPlaintext = (e) => plaintext.get()[e.id];
export const setPlaintext = (e, content) => plaintext.update(assoc(e.id, content));
export const ensurePlaintext = async (e) => {
    if (e.content && !getPlaintext(e)) {
        const $session = getSession(e.pubkey);
        if (!$session)
            return;
        const $signer = getSigner($session);
        if (!$signer)
            return;
        let result;
        try {
            result = await decrypt($signer, e.pubkey, e.content);
        }
        catch (e) {
            if (!String(e).match(/invalid base64/)) {
                throw e;
            }
        }
        if (result) {
            setPlaintext(e, result);
        }
    }
    return getPlaintext(e);
};
//# sourceMappingURL=plaintext.js.map